module.exports = __webpack_public_path__ + "img/login-button-r.39b7c0d0.svg";